import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//import PersonalData from './PersonalData/PersonalData';
//import PreferenceData from './PreferenceData/PreferenceData';
import HeaderRegistro from "./HeaderRegistro";
import HeaderMiniso from "../Home/HeaderMiniso/HeaderMiniso";
import MyFooter from "../Home/MyFooter/MyFooter";
import Entrega from "../Home/Entrega";
import useUser from "../../hooks/useUser";
import WelcomeMinisoLover from "../Home/WelcomeMinisoLover";
//import UserExists from '../UserExists';
import RegistrandoUser from "./RegistrandoUser";
import UserExistsExpress from "./UserExistsExpress";
//import WelcomeExpress from './WelcomeExpress';
import PersonalExpress from "./PersonalExpress";
import PreferenceExpress from "./PreferenceExpress";
import { useNavigate } from "react-router";
import {getVariableByShortName} from "../../api/apiVariable";

const Express = () => {
  const [
    dataUser,
    setDataUser,
    dataAdmin,
    setDataAdmin,
    initialDataUser,
    dataLocalStorage,
    setDataLocalStorage,
  ] = useUser();
  const [statusExpress, setStatusExpress] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const getExpressStatus = async () => {
      const response = await getVariableByShortName("express");
      console.log('response statusExpress: ',response);
      if (response?.data?.status) {
        if(String(response.data.status).toUpperCase()==="ON"){
          setStatusExpress(true);
        }else{
          setStatusExpress(false);
        }
        //setStatusExpress(response.response.data.status);
      }
    };
    getExpressStatus();
  }, []);

  useEffect(() => {
    if (
      dataLocalStorage.email !== "" &&
      dataLocalStorage.email !== undefined &&
      dataLocalStorage.email !== null &&
      dataLocalStorage.email !== "default"&&
      dataLocalStorage.email !== false&&
      dataLocalStorage.email !== true
    ) {
      navigate("/retry_express");
    }
  }, [dataLocalStorage]);
  useEffect(() => {
    if (dataUser.pageReload || dataUser.userExist) {
      setIsRegistering(false);
    }
  }, [dataUser.pageReload, dataUser.userExist]);
  return (
    <div className="pt-3 pb-5 bg-white w-100">
      <HeaderMiniso />
      {dataUser.pageReload && <WelcomeMinisoLover isExpress={true} />}
      {dataUser.userExist && <UserExistsExpress />}
      {isRegistering && !dataUser.pageReload && !dataUser.userExist && (
        <RegistrandoUser />
      )}
      {statusExpress===false && (
        <>
        <div
      className="text-center alert alert-danger my-5 p-5"
      >
        <h3 className="fs-3">Registro Express Inactivo</h3>
        <p className="fs-6 test-muted">sentimos los inconvenientes que esto causa</p>
        </div>
      
      </>
      )}
      
      {!dataUser.userExist && !dataUser.pageReload && statusExpress===true && (
        <Container className={isRegistering ? "d-none" : ""} fluid>
          <Container fluid className="w-100">
            <HeaderRegistro />
          </Container>
          
          <Row className="w-75 ms-auto me-auto">
            <Col xs={12}>
              <PersonalExpress />
            </Col>
            <Col xs={12}>
              <PreferenceExpress setIsRegistering={setIsRegistering} />
            </Col>
          </Row>
        </Container>
      )}

      <Entrega />
      <MyFooter />
    </div>
  );
};

export default Express;
